import { render } from "./EmployeePayrollHistory.vue?vue&type=template&id=1792b0c9&scoped=true"
import script from "./EmployeePayrollHistory.vue?vue&type=script&lang=js"
export * from "./EmployeePayrollHistory.vue?vue&type=script&lang=js"

import "./EmployeePayrollHistory.vue?vue&type=style&index=0&id=1792b0c9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1792b0c9"]])

export default __exports__